import React from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { Stethoscope, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

const SymptomsPage = () => {
  return (
    <DashboardLayout>
      <div className="max-w-4xl mx-auto text-center py-12" data-testid="symptoms-page">
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-primary/20 to-accent/20 rounded-2xl mb-6">
            <Stethoscope className="w-10 h-10 text-primary" />
          </div>
          <h1 className="text-4xl font-heading font-bold text-foreground mb-4">
            Symptômes et Premiers Conseils
          </h1>
          <p className="text-lg text-muted max-w-2xl mx-auto">
            Cette section sera bientôt disponible pour vous aider à comprendre les symptômes.
          </p>
        </div>

        <Card className="p-8 bg-gradient-to-br from-slate-50 to-white border-slate-200">
          <h3 className="text-xl font-heading font-semibold text-foreground mb-4">
            Fonctionnalités à venir
          </h3>
          <ul className="space-y-3 text-left max-w-md mx-auto text-muted">
            <li className="flex items-center gap-2">
              <ArrowRight className="w-4 h-4 text-primary" />
              Guide des symptômes courants
            </li>
            <li className="flex items-center gap-2">
              <ArrowRight className="w-4 h-4 text-primary" />
              Premiers gestes à adopter
            </li>
            <li className="flex items-center gap-2">
              <ArrowRight className="w-4 h-4 text-primary" />
              Quand consulter un médecin
            </li>
            <li className="flex items-center gap-2">
              <ArrowRight className="w-4 h-4 text-primary" />
              Conseils de prévention
            </li>
          </ul>
          <Button
            className="mt-8 bg-primary hover:bg-primary/90"
            onClick={() => window.history.back()}
          >
            Retour au chat
          </Button>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default SymptomsPage;
